<template>
  <v-app class="app-background fill-height pb-12">
    <div class="mt-md-auto pt-md-8 pb-6 pb-sm-12 pb-md-6">
      <div
        :class="[
          {
            'bg-black pt-6': !isMdAndUp,
            'pb-6': !isMdAndUp && !cabinetSwitcherIsShown
          }
        ]"
      >
        <v-img
          v-if="getLogo"
          :src="getLogo"
          :lazy-src="getLogo"
          :max-height="isMdAndUp ? 32 : 26"
        />
        <div v-if="cabinetSwitcherIsShown" class="d-flex justify-center gap-5 mt-4 mt-md-5">
          <c-btn
            :label="$t('main.advertiser')"
            color="primary"
            variant="text"
            size="small"
            class="btn-border text-body-2 font-weight-medium px-2"
          />
          <c-btn
            :label="$t('main.publisher')"
            :color="isMdAndUp ? 'secondary-600' : 'white'"
            variant="text"
            size="small"
            class="text-body-2 font-weight-medium px-2"
            :href="helpUrls.publisher_cabinet_sign_up"
          />
        </div>
      </div>
    </div>
    <ad-block-alert
      v-if="isAdBlockDetected && isBeta"
      class="adblock-banner"
      :text="$t('main.adblock_cause')"
    />
    <v-main class="flex-md-grow-0 mb-md-auto">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
  import { mapState } from 'pinia'
  import { CBtn } from '@clickadilla/components/components'
  import AdBlockAlert from '@/components/AdBlockAlert.vue'
  import { useSettingsStore } from '@/store/settings/settings'

  export default {
    name: 'DefaultLayout',
    components: { AdBlockAlert, CBtn },
    props: {
      isAdBlockDetected: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapState(useSettingsStore, ['getAdNetworkImages', 'helpUrls']),
      isBeta() {
        return window.localStorage.getItem('isBeta')
      },
      isMdAndUp() {
        return this.$vuetify.display.mdAndUp
      },
      cabinetSwitcherIsShown() {
        return (
          Boolean(this.helpUrls.publisher_cabinet_sign_up) && !this.$route.meta.hideCabinetSwitcher
        )
      },
      getLogo() {
        return this.isMdAndUp
          ? this.getAdNetworkImages.theme_white_logo
          : this.getAdNetworkImages.theme_black_logo
      }
    }
  }
</script>

<style scoped lang="scss">
  .app-background {
    background-color: rgb(var(--v-theme-secondary-100));
  }
  .btn-border {
    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      height: 2px;
      background-color: rgb(var(--v-theme-primary));
    }
  }
  .gap-5 {
    gap: 20px;
  }
  .adblock-banner {
    position: absolute;
    top: 0;
    width: 100%;
  }
</style>
